export default {
  plate: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  sinisterVersion: {
    value: '',
    maxlength: '2',
    required: false,
    state: null
  },
  insurance: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  mechanicalWorkshop: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/carinspectionheader/form/carinspectionheader-form.js